var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"400"}},[_c('v-card-text',[_c('h2',{staticClass:"title mb-2"},[_vm._v("Logout")]),_c('v-form',{ref:"form"},[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" You were logged out ")])],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }